import React, { useState, useEffect } from 'react';
import axios from "axios";
import PageBreadcrumb from "../components/common/PageBreadCrumb";
import UserMetaCard from "./UserProfile/UserMetaCard";
import UserInfoCard from "./UserProfile/UserInfoCard";
import PageMeta from "../components/common/PageMeta";
import Loader from "../components/common/Loader";

// Define the UserData interface to match the expected type
export interface UserData {
  first_name: string;
  last_name: string;
  email: string;
  mobile_number: string;
  roles: string[];
  profile_image?: string;
}

function UserProfiles() {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const userId = sessionStorage.getItem("user_id");

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!userId) {
        setError("User ID not found in session storage.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/profile/show`,
          { user_id: userId },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.status === 200) {
          setUserData(response.data.data);
        } else {
          setError("Failed to fetch user data.");
        }
      } catch (error) {
        setError("Something went wrong while fetching data.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [userId]);

  return (
    <>
      <PageMeta
        title="Profile Dashboard"
        description="This is Profile Dashboard page"
      />
      <PageBreadcrumb pageTitle="" />
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
        <h3 className="mb-5 text-theme-xl font-semibold text-gray-800 dark:text-white/90 lg:mb-7">
          Profile
        </h3>
        {loading ? (
          <div className="flex justify-center">
            <Loader />
          </div>
        ) : error ? (
          <p className="text-center text-red-500">{error}</p>
        ) : (
          <div className="space-y-6">
            <UserMetaCard userData={userData} setUserData={setUserData} />
            <UserInfoCard userData={userData} setUserData={setUserData} />
          </div>
        )}
      </div>
    </>
  );
}

export default UserProfiles;